// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('customer.contacts', {
    controller: 'CustomerContactsController as vm',
    url: '/contacts',
    templateUrl: 'main/customer/contacts/contacts.tpl.html',
    data: { pageTitle: 'Contacts' },
  });
};

class CustomerContactsController {
  constructor($rootScope, customer) {
    'ngInject';
    $rootScope.pageTitle = `${customer.name || ''} - Contacts`;

    this.customer = customer;
  }
}

angular
  .module('main.customer.contacts', [])
  .config(config)
  .controller('CustomerContactsController', CustomerContactsController);
